import strings from '@/i18n/index';
import type { AlertTypes } from '@/chat-types/common';

export function getLoginAlertStrings(type: AlertTypes, count: string | number) {
  switch (type) {
    case 'INSERT_EMAIL_HP':
      return strings.LOGIN__INSERT_EMAIL_HP;
    case 'INSERT_PASSWORD':
      return strings.LOGIN__INSERT_PASSWORD;

    case 'ALL_INCONSISTENCY':
      return strings.LOGIN__LOGIN_FAILED;
    case 'FAIL_COUNT':
      return strings.LOGIN__PASSWORD_FAIL_COUNT.replace('{0}', count?.toString());
    case 'LOGIN_LOCKED':
      return strings.LOGIN__LOCK_STATE_ALERT;
    case 'DEACTIVATED':
      return strings.LOGIN__DEACTIVATED_ALERT;
    case 'FAILED_PASSWORD_RULE':
      return strings.BASIC__.PASSWORD_RULE;
    default:
      return '';
  }
}
